import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IUseTransferMissingTraysQueryParams } from '../../../types';

/**
 * This key is used to track useTransferMissingTraysQuery
 */
export const TRANSFER_MISSING_TRAYS_QUERY_KEY =
  'transfer-missing-trays-query-key';

/**
 * This hook fetches the list of missing trays during transfer.
 */
export const useTransferMissingTraysQuery = (
  options: IUseTransferMissingTraysQueryParams = {}
) => {
  const { limit = 20, search, inventoryTransferId } = options;

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      TRANSFER_MISSING_TRAYS_QUERY_KEY,
      limit,
      search,
      inventoryTransferId,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    retry: false,
    queryFn: () => INV_MGMT_SERVICE_API.getTransferMissingTrays(options),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;
      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
